var _g, _path, _g2, _g3, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 169,
    viewBox: "0 0 194 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74.6538,
    cy: 74.8411,
    r: 59.6538,
    fill: "#F0EEEE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.6538,
    cy: 74.8411,
    r: 61.1538,
    stroke: "white",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M193.097 151.786L84.1635 168.212L27.9678 118.58L121.771 52.3629L193.097 151.786Z",
    fill: "url(#paint0_linear)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.078 83.1408L24.6834 54.4378V52.2764C24.6834 52.2764 23.2137 46.1381 29.7842 42.6799L73.4439 10L120.475 45.0142C120.475 45.0142 124.885 48.2995 121.34 53.4003L81.83 89.1062L56.4123 87.1177L54.078 83.1408Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0947 21.9308V88.7604C36.0947 90.5759 37.5645 91.9592 39.2936 91.9592H107.334C109.149 91.9592 110.532 90.4895 110.532 88.7604V21.9308C110.532 20.1152 109.063 18.7319 107.334 18.7319H39.2936C37.478 18.7319 36.0947 20.1152 36.0947 21.9308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5947 88.7604V21.9308C36.5947 20.3914 37.7541 19.2319 39.2936 19.2319H107.334C108.795 19.2319 110.032 20.4001 110.032 21.9308V88.7604C110.032 90.2222 108.864 91.4592 107.334 91.4592H39.2936C37.8318 91.4592 36.5947 90.291 36.5947 88.7604Z",
    stroke: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.6826 52.8133L71.1984 87.138L71.4657 87.3396H71.8005H73.4431H73.7689L74.0321 87.1478L121.204 52.7727V113.486C121.204 114.823 120.745 115.737 120.088 116.4C119.406 117.089 118.456 117.559 117.422 117.867C116.396 118.173 115.353 118.3 114.556 118.348C114.161 118.372 113.832 118.377 113.606 118.375C113.492 118.374 113.405 118.372 113.347 118.37C113.319 118.369 113.297 118.368 113.284 118.368L113.271 118.367L113.27 118.367L113.269 118.367L113.269 118.367L113.269 118.367L113.241 118.365H113.212H31.0803C28.2074 118.365 26.9404 117.231 26.3335 116.247C26.0105 115.723 25.8453 115.192 25.7621 114.787C25.7209 114.587 25.7009 114.422 25.6913 114.313C25.6865 114.259 25.6843 114.219 25.6833 114.195C25.6829 114.184 25.6827 114.176 25.6826 114.173V52.8133Z",
    fill: "white",
    stroke: "#BFBFBF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.0801 119.279L71.7139 90.4031H73.7888L114.595 119.365L31.0801 119.279Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2095 33.948H48.4575V37.9249H76.2095V33.948Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2095 43.2852H48.4575V47.2621H76.2095V43.2852Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6504 33.948H81.5698V37.9249H97.6504V33.948Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6504 43.2852H81.5698V47.2621H97.6504V43.2852Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6504 53.7461H81.5698V57.723H97.6504V53.7461Z",
    fill: "#EF8B22"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.4855 92.1119C-6.65646 108.319 25.0817 82.862 25.0817 82.862V80.4111C25.0817 80.4111 3.79624 95.2743 27.3623 99.0691C27.2673 99.0691 44.0866 101.046 78.4855 92.1119Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4854 97.0926C-6.65654 113.3 25.0817 87.8427 25.0817 87.8427V80.4111C25.0817 80.4111 2.94093 94.4837 27.3622 104.05C27.2672 104.05 44.0866 106.026 78.4854 97.0926Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6734 91.6998L86.3248 85.2157L81.5698 105.533H91.512L102.751 116.339L122.204 88.2416V85.2157L102.751 106.829L93.6734 91.6998Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1118 70.8545L88.2892 86.3074L85.2861 98.408L93.4613 92.1124L102.554 106.829L144.682 60.1438L78.1118 70.8545Z",
    fill: "#EF8B22",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.4152 86.0075L142.521 61.4407L140.359 63.602L93.9716 90.8581L86.7573 96.4549L89.4152 86.0075Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0.187256,
    width: 153.308,
    height: 153.308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.766667 0 0 0 0 0.753889 0 0 0 0 0.753889 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 31.0947,
    y: 13.7319,
    width: 88.4376,
    height: 87.2273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.505882 0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 44.3942,
    y1: 35.0719,
    x2: 111.829,
    y2: 134.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 104.913,
    y1: 85.2157,
    x2: 104.48,
    y2: 108.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110.922,
    height: 109.365,
    fill: "white",
    transform: "translate(24.5098 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140.921,
    height: 57.0602,
    fill: "white",
    transform: "translate(15.8643 55.821)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailUs);
export default __webpack_public_path__ + "static/media/email-us.c5eb21d04e76b6a49279cd0b50218451.svg";
export { ForwardRef as ReactComponent };